import React from 'react'
import "../Footer/Footer.scss"
function footer() {
  return (
    <div className='footer'>
      <div className="Movie App"></div>
      <div>&#169; - Kartik Sethi, 2023, Movie, Inc. or its affiliates</div>
    </div>
  )
}

export default footer
